import React, { Fragment } from 'react';
import { Col, DatePicker, Form, Input, Radio, RadioChangeEvent, Switch } from 'antd';
import { Row } from 'antd';
import Box from '../../components/Box';
import TextAreaSuggestInput from './components/TextAreaSuggestInput';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Text from '../../components/Text';
import styled from 'styled-components';
import CouponUpload from './components/SalonSmsCreateInfoForm/CouponUpload';
import AliceCarouselInfo from './components/SalonSmsCreateInfoForm/AliceCarouselInfo';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import SelectExpiresDay from './components/SalonSmsCreateInfoForm/SelectExpiresDay';
import DiscountValue from './components/SalonSmsCreateInfoForm/DiscountValue';

const SalonSmsCampCreateInfoForm = () => {
  const form = Form.useFormInstance();

  const handleChangeSendTimeType = (e: RadioChangeEvent) => {
    if (e.target.value === 'now') {
      form.setFieldsValue({ sendTime: dayjs() });
    }
  };

  return (
    <div>
      <Row>
        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
          <Box p={1}>
            <Form.Item
              label={'Title'}
              name={'title'}
              rules={[
                {
                  required: true,
                  message: 'Title is required',
                },
              ]}
            >
              <Input size='large' placeholder='Please enter...'></Input>
            </Form.Item>
            <Form.Item
              name='message'
              label='Message'
              rules={[
                {
                  required: true,
                  message: 'Message is required',
                },
              ]}
            >
              <TextAreaSuggestInput />
            </Form.Item>

            <Box display='flex' alignItems='center' gap={1} style={{ marginBottom: 8 }}>
              <span>Send Time:</span>
              <Form.Item name={'sendTimeType'} noStyle>
                <Radio.Group onChange={handleChangeSendTimeType}>
                  <Row style={{ gap: 16 }}>
                    <Radio value='now'>Now</Radio>
                    <Radio value='schedule'>Schedule</Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
            </Box>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const isNow = getFieldValue('sendTimeType') === 'now';
                return (
                  <Form.Item
                    name='sendTime'
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: 'Send time is requied',
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      size='large'
                      showTime={true}
                      disabled={isNow}
                      inputReadOnly={true}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Box>
        </Col>

        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
          <>
            <Row>
              <Box
                display='flex'
                alignItems='center'
                justifyContent='space-between'
                style={{ padding: '16px 0' }}
              >
                <Form.Item name='isCoupon' noStyle>
                  <Switch
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                  />
                </Form.Item>
                <Text variant='H6' style={{ fontWeight: 'bold' }} ml={0.5}>
                  Coupon
                </Text>
              </Box>
            </Row>

            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue, getFieldError }) => {
                const isCoupon = getFieldValue('isCoupon');
                const couponVisibleTemplate = getFieldValue('couponVisibleTemplate');
                const errorTemplateCouponId = getFieldError('templateCouponId');

                if (!isCoupon) {
                  return null;
                }

                return (
                  <Fragment>
                    <Form.Item noStyle name={'couponVisibleTemplate'}>
                      <Radio.Group>
                        <Box display='flex' gap={1}>
                          <Radio value='template'>Template</Radio>
                          <Radio value='uploadFile'>Upload Image</Radio>
                          <Radio value='uploadVideo'>Upload Video</Radio>
                        </Box>
                      </Radio.Group>
                    </Form.Item>
                    {errorTemplateCouponId && (
                      <div style={{ color: 'red' }}>{errorTemplateCouponId}</div>
                    )}
                    <Box
                      display='flex'
                      alignItems='center'
                      justifyContent='center'
                      style={{
                        height: couponVisibleTemplate === 'uploadVideo' ? '100px' : '200px',
                      }}
                    >
                      {couponVisibleTemplate === 'template' ? <AliceCarouselInfo /> : null}
                      {couponVisibleTemplate === 'uploadFile' ? (
                        <CouponUploadFormItem
                          name={'couponImage'}
                          rules={[{ required: true, message: 'Please upload image' }]}
                        >
                          <CouponUpload />
                        </CouponUploadFormItem>
                      ) : null}
                      {couponVisibleTemplate === 'uploadVideo' ? (
                        <Form.Item
                          style={{ width: '100%' }}
                          name={'urlImage'}
                          label={'Link'}
                          rules={[
                            {
                              required: true,
                              message: 'Coupon link is required',
                            },
                          ]}
                        >
                          <Input
                            placeholder='Enter Link..'
                            size='large'
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      ) : null}
                    </Box>

                    <Row gutter={16}>
                      <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                        <Form.Item
                          name={'couponTitle'}
                          label={'Title'}
                          style={{ marginBottom: 16 }}
                          rules={[
                            {
                              required: true,
                              message: 'Coupon title is required',
                            },
                          ]}
                        >
                          <TextArea
                            placeholder='Enter Title..'
                            autoSize={{ minRows: 1, maxRows: 2 }}
                            showCount
                            count={{ max: 155 }}
                            maxLength={155}
                          />
                        </Form.Item>
                        <Form.Item
                          name={'couponSubTitle'}
                          label={'Sub Title'}
                          rules={[
                            {
                              required: true,
                              message: 'Coupon title is required',
                            },
                          ]}
                        >
                          <TextArea
                            placeholder='Enter Title..'
                            autoSize={{ minRows: 1, maxRows: 2 }}
                            showCount
                            count={{ max: 155 }}
                            maxLength={155}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                        <Box display='flex' height='100%'>
                          <CouponDescriptionFormItem
                            style={{ width: '100%' }}
                            name={'description'}
                            label={'Text Coupon'}
                            rules={[
                              {
                                required: true,
                                message: 'Coupon description is requied',
                              },
                            ]}
                          >
                            <TextArea
                              placeholder='Enter Title..'
                              autoSize={{ minRows: 3, maxRows: 10 }}
                              showCount
                              count={{ max: 255 }}
                              maxLength={255}
                            />
                          </CouponDescriptionFormItem>
                        </Box>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                        <DiscountValue />
                      </Col>

                      <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                        <SelectExpiresDay />
                      </Col>
                    </Row>
                  </Fragment>
                );
              }}
            </Form.Item>
          </>
        </Col>
      </Row>
    </div>
  );
};

export default SalonSmsCampCreateInfoForm;

export const CouponUploadFormItem = styled(Form.Item)`
  margin: 0;
  .ant-upload-wrapper.ant-upload-picture-card-wrapper {
    .ant-upload-select {
      height: 150px;
      width: 200px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn-trash {
        position: absolute;
        z-index: 2;
      }
    }
  }
`;

export const CouponDescriptionFormItem = styled(Form.Item)`
  .ant-row.ant-form-item-row {
    height: 100%;
    .ant-form-item-control-input {
      height: 100%;
      .ant-form-item-control-input-content {
        height: 100%;
        .ant-input-affix-wrapper {
          height: 100% !important;
        }
      }
    }
  }
`;
